type Rgb = [number, number, number];

const INFERNO_STOPS: ReadonlyArray<readonly [number, number, number]> = [
    [0, 0, 4],
    [27, 12, 65],
    [74, 12, 107],
    [120, 28, 109],
    [165, 44, 96],
    [207, 68, 70],
    [237, 105, 37],
    [251, 155, 6],
    [247, 209, 61],
    [252, 255, 164],
];

const TURBO_STOPS: ReadonlyArray<readonly [number, number, number]> = [
    [48, 18, 59],
    [64, 91, 220],
    [35, 168, 250],
    [27, 229, 194],
    [88, 252, 120],
    [173, 250, 56],
    [235, 216, 41],
    [254, 153, 39],
    [238, 78, 17],
    [176, 24, 2],
];

function sampleStops(
    stops: ReadonlyArray<readonly [number, number, number]>,
    t: number
): Rgb {
    const clamped = t <= 0 ? 0 : t >= 1 ? 1 : t;
    const scaled = clamped * (stops.length - 1);
    const i = Math.floor(scaled);
    const f = scaled - i;
    const a = stops[i];
    const b = stops[Math.min(i + 1, stops.length - 1)];
    return [
        Math.round(a[0] + (b[0] - a[0]) * f),
        Math.round(a[1] + (b[1] - a[1]) * f),
        Math.round(a[2] + (b[2] - a[2]) * f),
    ];
}

export function turbo(t: number): Rgb {
    return sampleStops(TURBO_STOPS, t);
}

export function inferno(t: number): Rgb {
    return sampleStops(INFERNO_STOPS, t);
}

export function infernoGradientCss(direction = 'to top'): string {
    const stops = INFERNO_STOPS.map(
        (c, i) =>
            `rgb(${c[0]},${c[1]},${c[2]}) ${(
                (i / (INFERNO_STOPS.length - 1)) *
                100
            ).toFixed(0)}%`
    );
    return `linear-gradient(${direction}, ${stops.join(', ')})`;
}
